import { render, staticRenderFns } from "./upd.vue?vue&type=template&id=85c9b2c2&"
import script from "./upd.vue?vue&type=script&lang=js&"
export * from "./upd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports